export const space = {
  18: "4.5rem",
}
